'use strict';

var React = require('react');
var styled = require('styled-components');
require('../../theme/breakpoints.js');
var cssUnits = require('../../helpers/css-units.js');
require('../../theme/theme.js');
var useMatchDevice = require('../../hooks/useMatchDevice.js');
require('imask');
var useIsomorphicLayoutEffect = require('../../hooks/useIsomorphicLayoutEffect.js');
var useResizeObserver = require('../../hooks/useResizeObserver.js');
var useWindowResize = require('../../hooks/useWindowResize.js');

const getMaxBodyHeight = ({ dividersAreDisplayed, documentHeight, footer, header, minSpaceToSide, }) => {
    const headerHeight = header?.clientHeight ?? 0;
    const footerHeight = footer?.clientHeight ?? 0;
    const dividerHeight = 1;
    const headerDividerHeight = dividersAreDisplayed && header ? dividerHeight : 0;
    const footerDividerHeight = dividersAreDisplayed && footer ? dividerHeight : 0;
    const dialogMaxHeight = documentHeight - minSpaceToSide;
    const bodyMaxHeight = dialogMaxHeight - (headerHeight + headerDividerHeight + footerDividerHeight + footerHeight);
    return bodyMaxHeight;
};
const useMaxBodyHeight = ({ headerRef, footerRef, isOpened }) => {
    const html = React.useMemo(() => globalThis.document?.querySelector('html') || null, []);
    const [maxHeight, setMaxHeight] = React.useState(null);
    const theme = styled.useTheme();
    const isMobile = useMatchDevice.useMatchDevice('mobile');
    const isTablet = useMatchDevice.useMatchDevice('tablet');
    const isLaptop = useMatchDevice.useMatchDevice('laptop');
    const isDesktop = useMatchDevice.useMatchDevice('desktop');
    const minSpaceToSide = React.useMemo(() => {
        switch (true) {
            case isMobile:
                return (html?.clientHeight ?? 0) / 10;
            case isTablet:
                return cssUnits.remToPx(theme.designTokens.modalTabletGutterY);
            case isLaptop:
                return cssUnits.remToPx(theme.designTokens.modalLaptopGutterY);
            case isDesktop:
                return cssUnits.remToPx(theme.designTokens.modalDesktopGutterY);
            default:
                return 0;
        }
    }, [isMobile, isTablet, isLaptop, isDesktop, theme, html]);
    const setComputedMaxHeight = React.useCallback(() => {
        if (!isOpened || !html) {
            setMaxHeight(null);
            return;
        }
        const nextMaxHeight = getMaxBodyHeight({
            dividersAreDisplayed: isMobile,
            documentHeight: html.clientHeight,
            footer: footerRef.current,
            header: headerRef.current,
            minSpaceToSide,
        });
        setMaxHeight(nextMaxHeight);
    }, [isOpened, minSpaceToSide, isMobile, html]);
    useIsomorphicLayoutEffect.useIsomorphicLayoutEffect(setComputedMaxHeight, [setComputedMaxHeight]);
    useWindowResize.useWindowResize({ listener: setComputedMaxHeight });
    useResizeObserver.useResizeObserver({
        elementRefs: [React.useRef(html), headerRef, footerRef],
        observer: setComputedMaxHeight,
    });
    return maxHeight;
};

exports.useMaxBodyHeight = useMaxBodyHeight;
//# sourceMappingURL=useMaxBodyHeight.js.map
